module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filter-container"></div>\n<div class="data-container"><div class="data-container-content"></div></div>\n<div class="graphs-container"></div>';

}
return __p
}